import { Role } from "src/auth/types/interfaces";
import { ROLE_TO_COUNTRY_MAP, CountryCode } from "./constants";

/**
 * Maps user roles to accessible country codes.
 * Roles that do not have a country mapping are silently filtered out.
 * @param roles - Array of user roles
 * @returns Array of unique country codes the user has access to
 */
export function getUserAccessibleCountries(roles: Role[]): CountryCode[] {
  const countries = roles
    .map((role) => ROLE_TO_COUNTRY_MAP[role])
    .filter((country): country is CountryCode => country !== undefined);

  return Array.from(new Set(countries));
}

/**
 * Determines if the country filter should be visible.
 * The filter is shown only when the user has access to more than one country.
 * @param accessibleCountries - Array of countries user has access to
 * @returns true if filter should be shown, false otherwise
 */
export function shouldShowCountryFilter(
  accessibleCountries: CountryCode[]
): boolean {
  return accessibleCountries.length > 1;
}

/**
 * Gets default selected countries (all accessible countries).
 * When the filter is first displayed, all accessible countries are pre-selected.
 * @param accessibleCountries - Array of countries user has access to
 * @returns Copy of the accessible countries array to pre-select
 */
export function getDefaultSelectedCountries(
  accessibleCountries: CountryCode[]
): CountryCode[] {
  return [...accessibleCountries];
}
